var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M9.115 1.014L6.926 2.407A2 2 0 0 0 6 4.094v9.301l-4.567-2.637a1 1 0 0 1-.366-1.366L5.6 1.542a1 1 0 0 1 .856-.5l2.659-.028zM7.463 3.251L11 1l3.537 2.25a1 1 0 0 1 .463.844V14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4.094a1 1 0 0 1 .463-.843zM11 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" })
  );
});